<template>
    <!-- <v-container class="fill-height fluid" @keyup.enter="login"> -->
    <v-container @keyup.enter="login" class="mycontainer">
        <!-- <v-img src="../assets/background-large.png" style="width:100%; height:100%; position:absolute; top:0; left:0;"></v-img> -->
        <!-- <v-img src="../assets/background-large.png" height="1500px" style="position:absolute; top:0; left:0;"></v-img> -->
        <v-row class="align-center">
            <v-col>
                <div class="d-flex justify-center ma-3">
                    <div v-if="!forgottenPassword" style="max-width: 600px;">
                        <v-card class="elevation-12">
                            <v-toolbar :color="appColors.primary1" dark flat>
                                <v-toolbar-title>
                                    <div class="d-flex">
                                        Logg inn
                                        <div class="mx-1"></div>
                                        <v-img src="../assets/white-butterfly.png" width="18px" height="18px"></v-img>
                                    </div>
                                </v-toolbar-title>
                                <v-spacer />
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn href="http://sparebankstiftelsentelemark-hollaoglunde.no/" icon large target="_blank" v-on="on">
                                            <v-icon>mdi-home</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Sparebankstiftelsen Holla og Lunde</span>
                                </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                                <!-- Why form contents outside the form: https://github.com/KillerCodeMonkey/ngx-quill/issues/351 (mariordev post) -->
                                <v-form id="form-login" ref="form">
                                </v-form>
                                <v-text-field form="form-login" :autofocus="!input.email" v-model="input.email" label="brukernavn" name="login" prepend-icon="mdi-account" type="text" :rules="[v => !!v || 'påkrevd']" />
                                <v-text-field form="form-login" :autofocus="input.email && !input.password" v-model="input.password" id="password" label="passord" name="password" prepend-icon="mdi-lock" :type="input.showPassword? 'text':'password'" :rules="[v => !!v || 'påkrevd']">
                                    <template v-slot:append tabindex="-1">
                                        <v-icon tabindex="-1" @click.stop="input.showPassword = !input.showPassword">{{input.showPassword? 'mdi-eye-off':'mdi-eye'}}</v-icon>
                                    </template>
                                </v-text-field>
                            </v-card-text>
                            <v-card-actions>
                                <v-row no-gutters>
                                    <v-col cols="12" sm="4">
                                        <div :class="{'d-flex': true, 'justify-start': $vuetify.breakpoint.smAndUp, 'justify-center': $vuetify.breakpoint.xsOnly}">
                                            <v-btn tabindex="-1" text color="#CCCCCC" small @click="forgottenPassword = true">
                                                <v-icon left>mdi-lock-reset</v-icon>
                                                GLEMT PASSORD
                                            </v-btn>
                                        </div>

                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <div class="d-flex justify-center">
                                            <v-btn tabindex="-1" text color="#CCCCCC" small to="/registeruser">
                                                <v-icon left>mdi-account-plus</v-icon>
                                                Registrer ny bruker
                                            </v-btn>
                                        </div>

                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <div :class="{'d-flex': true, 'justify-end': $vuetify.breakpoint.smAndUp, 'justify-center': $vuetify.breakpoint.xsOnly}">
                                            <v-btn @click="login" :color="appColors.primary1" dark>
                                                <v-icon left>mdi-login</v-icon>
                                                LOGG INN
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card-actions>
                        </v-card>
                    </div>
                    <div v-if="forgottenPassword" style="max-width: 550px;">
                        <v-card class="elevation-12">
                            <v-toolbar :color="appColors.primary1" dark flat>
                                <v-toolbar-title>Glemt passord</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <v-form ref="resetForm">
                                    <v-text-field v-model="input.email" label="brukernavn" persistent-hint hint="brukeren vil tilsendes e-post med instruksjoner" prepend-icon="mdi-account" type="text" :rules="[v => !!v || 'Påkrevd']"></v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn text color="#CCCCCC" small @click="forgottenPassword = false">
                                    <v-icon left>mdi-login</v-icon>
                                    LOGG INN
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn :color="appColors.primary1" dark @click="reset">
                                    <v-icon left>mdi-lock-reset</v-icon>
                                    Nullstill
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </div>
                </div>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as axios from "axios";
import { colors as appColors } from "../utilities/colors";
// import { Role } from "../utilities/enums";
// import * as jwt from "jsonwebtoken";

export default {
    data: () => ({
        appColors,
        input: {
            email: "",
            password: "",
            showPassword: false,
        },
        forgottenPassword: false
    }),
    computed: {
        hasCompany() {
            return this.$store.getters.company && this.$store.getters.company.id;
        }
    },
    methods: {
        async login() {
            if (!this.$refs.form.validate()) {
                return;
            }

            let email = this.input.email;
            let password = this.input.password;

            try {
                await this.$store.dispatch("login", { email, password });
                await this.$store.dispatch("fetchCompanies");

                this.$router.push({name: "home"});
                
                    // if(this.$store.getters.user.role === Role.REVISOR){
                    //     this.$router.push({ name: "exportadmin" });
                    // }
                    // else if(this.$store.getters.user.role === Role.SUPERUSER){
                    //     this.$router.push({ name: "applicationadmin" });
                    // }
                    // else {
                        
                    //     this.$router.push({ name: "applications" });
                    // }
                
            } catch (error) {
                // console.log(error);
                this.$store.commit("snackbar", {
                    text: `Innlogging feilet: ${JSON.stringify(error)}`,
                    color: "error",
                    show: true
                });
                // console.log(error);
            }
        },
        async reset() {
            if (!this.$refs.resetForm.validate()) {
                return;
            }

            await axios.post("/authenticate/passwordresetrequest", {
                username: this.input.email
            });

            this.forgottenPassword = false;
        }
    },
    watch: {
        forgottenPassword: function(val) {
            if (val) {
                this.input.password = undefined;
            }
        }
    },
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.$router.replace({ name: "home" });
            return;
        }

        if (localStorage.getItem("email")) {
            this.input.email = localStorage.getItem("email");
        }
    }
};
</script>

<style lang="scss" scoped>
.mycontainer {
    display: flex;
    background-color: rgb(227, 229, 229);
    background-image: url("../assets/background-large.png");
    background-position: top left;
    background-size: cover;

    max-width: 6000px;
   
    width: 100vw;
    height: 100vh;

    margin: 0;
    padding: 0;

}
</style>